<template>
  <div :class="hasWebp ? 'about' : 'about noWebp'">
    <div class="about_box about_main">
      <div class="about_inner">
        <div class="ab_title">Our story<br>关于我们</div>
        <em class="ab_title_line"></em>
        <div class="ab_sub">品牌全球化操盘手的故事</div>
      </div>
    </div>
    <div class="about_box about_banner">
      <div class="about_inner">
        <div class="ab_title wt">中国品牌全球化的信仰者，追求者和方法论者</div>
        <div class="ab_sub wt">打造全球品牌是中国企业当前最大的机会，而一系列“黑天鹅”事件也让我们认<br>识到了，中国品牌全球化已经从十年前的“可选项”变为了现在的“必选项”</div>
      </div>
    </div>
    <div class="about_box about_ant">
      <div class="about_inner">
        <div class="ab_bottom">
          <div class="ab_ant_item">
            <img src="../../static/imgs/about_cn_ant_1.svg" alt="">
            <div class="ab_ant_title">我们的信念</div>
            <div class="ab_ant_res">工程化的认知迭代是品牌出海科学的且唯一的成功道路</div>
          </div>
          <div class="ab_ant_item">
            <img src="../../static/imgs/about_cn_ant_2.svg" alt="">
            <div class="ab_ant_title">我们的使命</div>
            <div class="ab_ant_res">赋能中国品牌天生国际化能力，实现全球商业增长</div>
          </div>
        </div>
      </div>
    </div>
    <div class="about_box about_story">
      <div class="about_inner">
        <div class="ab_title">创办故事</div>
        <div class="ab_bottom column">
          <div class="ab_story_des">五位创始人曾就职于大疆，阿里，腾讯，CEO蓝大曾担任大疆的全球电商负责人，经历了该品牌的起步到腾飞阶段；</div>
          <div class="ab_story_des">他观察到:“除了高端品牌拥有数智化能力和大量人才资金资源，大部分品牌在未知的场景中缺乏资源，难以降低风险，品牌出海之路极具挑战性”；</div>
          <div class="ab_story_des">大疆DTC品牌出海智造到垄断全球80%的市场份额，他们看到中国品牌出海的真正可复制化的科学道路，即“数据+方法论+技术”；</div>
          <div class="ab_story_des">为了帮助更多中国品牌实现全球商业增长，他们创建了以全球零售数据资源为基础，以工程化的选代测试为方法论，以高效率的技术平台为支撑的品牌出海解决方案ANTDIY。</div>
        </div>
      </div>
    </div>
    <FooterCN></FooterCN>
    <Sidebanner></Sidebanner>
  </div>
</template>

<script>
import FooterCN from './common/footerCNNew.vue';
import Sidebanner from './common/sidebanner.vue'

export default {
  name:'about-us',
  components:{
    FooterCN,
    Sidebanner
  },
  props: ['hasWebp'],
  data(){
    return{

    }
  },
  methods:{
    consult(){
      if (window.fcWidget.isLoaded()) {
        window.fcWidget.open()
      }
    }
  },
  created(){
    document.title = '全球云店——想法即商业，开店即开张';;
  }
}
</script>
<style scoped>
  .about {
    width: 100%;
  }
  .about_box {
    width: 100%;
  }
  .about_inner {
    width: 1200px;
    margin: 0 auto;
  }
  .ab_bottom {
    display: flex;
    justify-content: space-between;
  }
  .ab_title {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 44px;
    color: #222536;
    letter-spacing: 0.61px;
    font-weight: 700;
  }
  .ab_title_line {
    display: inline-block;
    width: 60px;
    height: 8px;
    background: #FC5421;
    border-radius: 6px;
    margin-top: 30px;
  }
  .ab_sub {
    font-family: SourceHanSansCN-Regular !important;
    font-size: 32px;
    color: #222536;
    letter-spacing: 0.5px;
    line-height: 46px;
    font-weight: 400;
  }
  .wt {
    color: #FFFFFF;
  }
  .column {
    flex-direction: column;
  }

  .about_main {
    height: 750px;
    background: url("../../static/imgs/about_cn_bg_main.webp") center/cover, #02021D;
  }
  .noWebp .about_main {
    background: url("../../static/imgs/about_cn_bg_main.png") center/cover, #02021D;
  }
  .about_main .ab_title {
    font-size: 70px;
    color: #FFFFFF;
    letter-spacing: 5.83px;
    line-height: 100px;
    padding-top: 155px;
  }
  .about_main .ab_sub {
    font-size: 42px;
    color: #FFFFFF;
    letter-spacing: 3.5px;
    line-height: 48px;
    margin-top: 30px;
  }

  .about_banner {
    padding: 90px 0 100px;
    background: url("../../static/imgs/about_cn_bg_banner.jpg") center/cover;
    text-align: center;
  }
  .about_banner .ab_sub {
    margin-top: 40px;
  }

  .about_ant {
    text-align: center;
    padding: 130px 0 120px;
  }
  .about_ant .ab_bottom {
    margin-top: 0;
  }
  .ab_ant_item {
    width: 536px;
    text-align: left;
  }
  .ab_ant_item img {
    width: 120px;
    height: 120px;
  }
  .ab_ant_title {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 44px;
    color: #222536;
    letter-spacing: 0.61px;
    font-weight: 700;
    margin-top: 60px;
  }
  .ab_ant_res {
    font-family: SourceHanSansCN-Regular !important;
    font-size: 28px;
    color: #222536;
    letter-spacing: 0.39px;
    line-height: 40px;
    margin-top: 25px;
  }

  .about_story {
    padding: 120px 0 310px;
    background: url("../../static/imgs/about_cn_bg_story.jpg") center/cover;
  }
  .about_story .ab_title {
    text-align: center;
  }
  .ab_bottom {
    margin-top: 80px;
  }
  .ab_story_des {
    font-family: SourceHanSansCN-Regular !important;
    font-size: 28px;
    color: #222536;
    line-height: 40px;
  }
  .ab_story_des + .ab_story_des {
    margin-top: 46px;
  }
  @media (max-width: 767px) {
    .about {
      margin-top: 1.6rem;
    }
    .about_box {
      padding: .7rem .48rem .75rem;
    }
    .about_inner {
      width: 100%;
    }
    .ab_bottom {
      flex-direction: column;
    }
    .ab_title {
      font-size: .4rem;
      letter-spacing: 0.0056rem;
    }
    .ab_title_line {
      width: .6rem;
      height: .08rem;
      border-radius: .06rem;
      margin-top: .3rem;
    }
    .ab_sub {
      font-size: .28rem;
      letter-spacing: .0039rem;
      line-height: .46rem;
    }
    .wt {
      color: #FFFFFF;
    }
    .column {
      flex-direction: column;
    }

    .about_main {
      height: fit-content;
      background: url("../../static/imgs/about_cn_mbg_main.webp") center/cover, #02021D;
    }
    .noWebp .about_main {
      background: url("../../static/imgs/about_cn_mbg_main.png") center/cover, #02021D;
    }
    .about_main .ab_title {
      font-size: .6rem;
      letter-spacing: .05rem;
      line-height: .68rem;
      padding-top: 1.5rem;
    }
    .about_main .ab_title_line{
      width: .36rem;
      height: .06rem;
      border-radius: .03rem;
      margin-top: .4rem;
    }
    .about_main .ab_sub {
      font-size: .34rem;
      letter-spacing: .0283rem;
      line-height: .32rem;
      margin: .95rem 0 1.65rem;
    }

    .about_banner {
      padding: 1rem 0.48rem;
      background: url("../../static/imgs/about_cn_mbg_banner.png") center/cover;
    }
    .about_banner .ab_sub {
      margin-top: .4rem;
    }

    .about_ant {
      text-align: center;
    }
    .about_ant .ab_bottom {
      margin-top: 0;
    }
    .ab_ant_item {
      width: 100%;
    }
    .ab_ant_item + .ab_ant_item {
      margin-top: .45rem;
    }
    .ab_ant_item img {
      width: 1.2rem;
      height: 1.2rem;
    }
    .ab_ant_title {
      font-size: .34rem;
      letter-spacing: 0.0047rem;
      margin-top: .45rem;
    }
    .ab_ant_res {
      font-size: .24rem;
      letter-spacing: 0.0033rem;
      line-height: .24rem;
      margin-top: .25rem;
    }

    .about_story {
      background: url("../../static/imgs/about_cn_mbg_story.png") center/cover;
    }
    .about_story .ab_title {
      text-align: center;
      line-height: .4rem;
    }
    .ab_bottom {
      margin-top: .48rem;
    }
    .ab_story_des {
      font-size: .28rem;
      line-height: .4rem;
    }
    .ab_story_des + .ab_story_des {
      margin-top: .35rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/aboutcn.vue